import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import WaitingModal from '../../generics/WaitingModal';
import Moment from 'react-moment';
var Config = require('../../../config');

class ModalGrupoRH extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.createRecords = this.createRecords.bind(this);
		this.getDonor = this.getDonor.bind(this);
		this.getGroupTest = this.getGroupTest.bind(this);
		this.state = {
		    show: false,
		    rhGroup:[],
		    lookup_group:"",
	    	lookup_rh:"",
	    	rh_group:"",
	    	donor:{
				donor:{},
				person:{},
				offer:{}
			},
			offers_id:"",
			group_test_id:"",
			lectina:'',
			du:"",
			lectinaValues:["1","2"],
			hide_fields:false
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ 
			show: false,
		    rhGroup:[],
		    lookup_group:"",
	    	lookup_rh:"",
	    	rh_group:"",
	    	donor:{
				donor:{},
				person:{},
				offer:{}
			},
			offers_id:"",
			group_test_id:"",
			lectina:'',
			du:"",
			lectinaValues:["1","2"],
			hide_fields:false
		});
	}

	handleShow(donor_id, offers_id, group_test_id, rh_group, caller, type) {
		console.log(this.state.du);
		this.setState({ 
			group_test_id:group_test_id === null ? 0 : group_test_id,
			offers_id:offers_id,
			show: true,
			lookup_group:"",
			lookup_rh:"",
			rh_group:rh_group,
			du:"",
			donor:{donor:{},person:{},offer:{}}
		});

		if(type === 'inverso'){
			this.setState({hide_fields:true});
		}

		this.getDonor(donor_id, offers_id);

		if(group_test_id !== 0 && group_test_id !== null){
			this.getGroupTest(group_test_id);
		}
		//grupos sanguineos
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_group_rh',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      rhGroup: response
		    });
		})
	}

	getDonor(id, offers_id){
		//donor
		this.waiting_modal.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'donors?id='+id+'&offer_id='+offers_id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			if(response !== undefined){
				this.waiting_modal.handleClose();
				this.setState({donor:response });
			}
				
		});
	}

	getGroupTest(id){
		fetch(Config.default.apiGateway.URL+'group_test/'+id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {

			var rh_group = response.RH === '' || response.RH === null ? response.group :
							response.RH === 'POSITIVO' ? response.group+' +' : response.group+' -'
			this.setState({
				rh_group: rh_group,
				lectina:parseFloat(response.lectina),
				lookup_rh:response.RH, 
				lookup_group:response.group,
				du:response.du
			});
		})
	}

	//Evento de cambio en elementos formulario
	handleChange = (event, index) => {
	    this.setState({
	      [event.target.name]: event.target.value
	    });

	    if(event.target.name === 'rh_group'){
	    	 this.setState({du:""});
	    }

	    if(event.target.required){
	    	if (event.target.value.length > 0) {
	    		this.setState({['errorText_'+event.target.name]: ""})
	    	} else{
	    		this.setState({['errorText_'+event.target.name]: "Campo obligatorio"})
	    	};
	    }
	}

	createRecords(){
		//if(this.isValidForm()){
			var obj = {};
			var urlApi = '';
			obj.offers_id = this.state.offers_id !== 0 ? this.state.offers_id : null;


			if(!this.state.hide_fields){
				obj.group= this.state.rh_group !== "" ? this.state.lookup_group : "";
				obj.rh = this.state.rh_group !== "" ? this.state.lookup_rh : "";
				obj.lectina = parseFloat(this.state.lectina);
				obj.du = this.state.du;

				urlApi = 'group_test';
			}else{
				obj.group= this.state.rh_group;
				urlApi = 'group_test/inverse_group';

				if(this.state.group_test_id !== 0){
					urlApi = 'inverse_group_update';
				}
			}


			if(this.state.offers_id === 0){
				obj.samples_id = this.props.state.sample.id;
			}

			if(this.state.group_test_id === 0){//CREAR REGISTRO
				this.waiting_modal.handleShow('Guardando');
				fetch(Config.default.apiGateway.URL+urlApi, {
				  method: 'POST', // or 'PUT',
				  body: JSON.stringify(obj), // data can be `string` or {object}!
				  headers: new Headers({
				  	'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				  	'Accept': 'application/json',
				  	'Content-Type': 'application/json;charset=UTF-8'
				  })
				}).then(res => {
					this.waiting_modal.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then(function(result) {
							swal('¡Error!', result, 'error');
						});
					}
				}).then(response => {
			    	if(response !== undefined){
			    		this.setState({ show: false});

			    		if(!this.state.hide_fields){
			    			if(this.props.refresh !== undefined){
				    			this.props.refresh();
				    		}else{
				    			var rh_group = response.RH === '' || response.RH === null ? response.group :
												response.RH === 'POSITIVO' ?
													response.lectina === null ?
														response.group+'+'
													: response.group+response.lectina+'+' 
												: response.lectina === null ?
													response.group+'-'
												: response.group+response.lectina+'-';
				    		
					    		if(this.props.updateGroupTestData !== undefined){
					    			this.props.updateGroupTestData(response.id, rh_group);
					    		}
				    			else if(this.props.location.pathname.indexOf('/results_donation/new') !== -1){

				    				this.props.update(rh_group);
				    				this.props.history.push('/results_donation/new/'+this.props.match.params.donation_id+'/'+response.id);
				    				
				    			}else{
				    				if(this.state.offers_id !== 0){
				    					this.props.update(rh_group);
				    					this.props.history.push('/results_donation/edit/'+this.props.match.params.sample_id+'/'+this.props.match.params.donation_id+'/'+response.id);
				    				}else{
				    					this.props.update(rh_group);
				    					this.props.history.push('/sample_results/edit/'+this.props.match.params.sample_id+'/0/'+response.id);
				    				}
				    				
				    			}
				    			
				    		}
			    		}else{
			    			this.props.refresh();
				    		
			    		}
			    	}
				}).catch(function(error) {
				  console.log('There has been a problem with your fetch operation: ' + error.message);
				});

			}else{//ACTUALIZAR REGISTRO
				this.waiting_modal.handleShow('Guardando');
				fetch(Config.default.apiGateway.URL+urlApi+'/'+this.state.group_test_id, {
				  method: 'PUT', // or 'PUT',
				  body: JSON.stringify(obj), // data can be `string` or {object}!
				  headers: new Headers({
				  	'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				  	'Accept': 'application/json',
				  	'Content-Type': 'application/json;charset=UTF-8'
				  })
				}).then(res => {
					this.waiting_modal.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then(function(result) {
							swal('¡Error!', result, 'error');
						});
					}})
				.then(response => {
			    	if(response !== undefined){
			    		this.handleClose();

			    		if(!this.state.hide_fields){
			    			var rh_group = response.RH === '' || response.RH === null ? response.group :
												response.RH === 'POSITIVO' ?
													response.lectina === null ?
														response.group+'+'
													: response.group+response.lectina+'+' 
												: response.lectina === null ?
													response.group+'-'
												: response.group+response.lectina+'-';
							
				    		if(this.props.updateGroupTestData !== undefined){
				    			this.props.updateGroupTestData(this.state.group_test_id, rh_group);
				    		}
				    		else if(this.props.refresh !== undefined){
				    			this.props.refresh();
				    		}else{
				    			this.props.update(rh_group);
				    		}
			    		}else{
			    			this.props.refresh();
				    		
			    		}
			    	}
				})
				.catch(function(error) {
				  console.log('There has been a problem with your fetch operation: ' + error.message);
				});
			}
		/*}else{
			swal('¡Error!', 'Campos Incompletos', 'error');
		}*/
	}

	//Verificar si el formulario es valido
	isValidForm() {
		let isFormValid = true;
	    const isSelectValid4 = this.showSelectError('rh_group');
	    if ( !isSelectValid4 ) {
	    	isFormValid = false;
	    } 
	    
	    return isFormValid;
	}

	//desplegar errores en selceted
	showSelectError(refName) {
		var res = null;
		var control = document.getElementById(refName);

		if (this.state[refName] === null) {
			control.classList.add('error');
			res = false;
		} else{
			control.classList.remove('error');
			res = true;
		};

		return res;
	}

	//Desplegar error en campos requeridos
	showInputError(refName) {
	    const validity = this.refs[refName].state;
	    if (!validity.hasValue) {//console.log('vacio')
	    	this.setState({['errorText_'+refName]: "Campo obligatorio"})
	      	return false;
	    }else {//console.log('valor')
	    	this.setState({['errorText_'+refName]: ""})
	    }
	    return true;
	}

	//seleccion de grupo y rh
	rhGroupHandleChange = (event) => {
		for(var i=0; i < this.state.rhGroup.length;i++){
			if(this.state.rhGroup[i].name === event.target.value){
				if(this.state.rhGroup[i].key_group !== "A" || this.state.rhGroup[i].key_group !== "AB"){
					this.setState({lectina:""});
				}
				this.setState({lookup_group:this.state.rhGroup[i].key_group, lookup_rh:this.state.rhGroup[i].key_rh});
			}
		}
		this.selectFieldHandle(event);
	}

	selectFieldHandle = (event) => {
		this.setState({[event.target.name]:event.target.value});

		if(event.target.id !== null){
			var control = document.getElementById(event.target.id);
			if(control.required && control.className.includes('error')){
				control.classList.remove('error');
			}
		}
	}



	render(){
		const { t } = this.props;
		return(
			<div>
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.modal_grupo_rh.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{paddingLeft:"10px",paddingRight:"10px"}}>
		        		<fieldset>
	        			<legend style={{fontSize:"1.2em"}}>{
	        				this.state.donor.person.lastname1 +' ' +
	        				this.state.donor.person.lastname2
	        				+', '+this.state.donor.person.names}
	        			</legend>
	        			<div className="col-xs-12" style={{paddingBottom:"10px",paddingRight:"0px",paddingLeft:"0px"}}>
							<div style={{padding:"0px"}} className="col-xs-12 col-md-5" >
								<div className="col-xs-12">
									<span >{t('content.modal_hc.birthday')}: 
									{this.state.donor.person.birthday !== null?
										<Moment format="DD/MM/YYYY">{this.state.donor.person.birthday}</Moment>:"No Definida"}
									</span>
								</div>
								<div className="col-xs-12">
									<span >{t('content.modal_hc.donor_number')}: {this.state.donor.donor.donor_number}</span>
								</div>
							</div>
							<div className="col-xs-12 col-md-2">
								<div className="form-group col-xs-12">
									<button className="btn btn-info" disabled style={{float:'right'}} type="button">{this.state.donor.person.sex}</button>
								</div>
							</div>
							<div className="col-xs-12 col-md-5">
								<div className="col-xs-6" >
									{this.state.donor.person.photo !== null && this.state.donor.person.photo !== undefined?
										<img style={{height:'100px',width:'94px'}} src={'data:image/jpeg;base64,'+this.state.donor.person.photo} alt="Donor"/>
										:<img style={{height:'100px',width:'94px'}} src="../../../default_user.jpg" alt="USER"/>
									}
								</div>
								<div className="col-xs-6" style={{padding:'0px'}}>
						        	<span style={{fontSize:'.7em',fontWeight:'bold'}}>
						        		{t('content.offers.form.last_donation')}
						        	</span><br/>
						        	<span className="text-modal-gp-rh">
										{this.state.donor.offer !== null && this.state.donor.offer !== undefined ?
											this.state.donor.offer.date
						        		: null}
						        	</span><br/>
						        	<div style={{padding:'0px'}}>
							        	<span className="text-modal-gp-rh">
							        		{this.state.donor.offer !== null && this.state.donor.offer !== undefined ?
							        			this.state.donor.offer.donation_type
							        		: null}
							        	</span><br/>
							        	<span className="text-modal-gp-rh">
							        		{this.state.donor.offer !== null && this.state.donor.offer !== undefined ?
							        			this.state.donor.offer.extraction_type
							        		:null}
							        	</span>
							        </div>
					        	</div>
							</div>
						</div>
		        		{!this.state.hide_fields ?
		        			<div style={{padding:"0px"}} className="col-xs-12">
			 					<div className="col-xs-2" >
			 						<span>{t('content.modal_grupo_rh.group')}:</span>
			 					</div>
			 					<div className="col-xs-4 form-group">
			 						<select className="form-control" 
						              	name="rh_group" 
						              	id="rh_group"
							        	value={ this.state.rh_group || "" } 
							        	onChange={ this.rhGroupHandleChange.bind(this)}	>
							        	<option value=""></option>
						                {
						                this.state.rhGroup.map(function(t,index) {
						                  return <option key={index}  value={t.name}>{t.name}</option>;
						                })
						              }
						              </select>
						        </div>
						        {this.state.lookup_group === "A" || this.state.lookup_group === "AB" ?
							        <div>
								        <div className="col-xs-2" >
					 						<span>{t('content.modal_grupo_rh.lectina')}:</span>
					 					</div>
					 					<div className="col-xs-4 form-group">
								 			<select className="form-control" name="lectina" 
								 				value={ this.state.lectina || ""} 
								 				onChange={ this.handleChange }>
									        	<option value=""></option>
								                {
								                	this.state.lectinaValues.map(function(s) {
								                  		return <option key={s} value={s}>{s}</option>;
								                	})
								              	}
					            			</select>
								        </div>
								    </div>:null
								}
								{this.state.lookup_rh === 'NEGATIVO' ?
									<div>
								        <div className="col-xs-2" >
					 						<span>DU:</span>
					 					</div>
					 					<div className="col-xs-4">
								 			<select className="form-control" name="du" 
								 				value={ this.state.du || ""} 
								 				onChange={ this.handleChange }>
									        	<option value=""></option>
								                <option value="POSITIVO">POSITIVO</option>
								                <option value="NEGATIVO">NEGATIVO</option>
					            			</select>
								        </div>
								    </div>
								:null}
				        	</div>
				        :
				        	<div style={{padding:"0px"}} className="col-xs-12">
				        		<div className="col-xs-2" >
			 						<span>{t('content.modal_grupo_rh.group')}:</span>
			 					</div>
			 					<div className="col-xs-4 form-group">
			 						<select className="form-control" 
						              	name="rh_group" 
						              	id="rh_group"
							        	value={ this.state.rh_group || "" } 
							        	onChange={this.state.hide_fields ?
							        		this.handleChange
							        	:this.rhGroupHandleChange.bind(this)}	>
							        	<option value="">Seleccione...</option>
						                <option value="A">A</option>
						                <option value="B">B</option>
						                <option value="AB">AB</option>
						                <option value="O">O</option>
						              </select>
						        </div>
						    </div>
				    	}
					    </fieldset>
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.createRecords}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
	      	<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
	      	</div>
		);
	}
}

export default translate('translations')(ModalGrupoRH);